import { useParams } from 'react-router-dom';

import { AppAdsPage } from '~/components/pages/AppAdsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppAdsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppAdsPage appId={appId} />
    </DashboardTemplate>
  );
};
